import { useSelector } from 'react-redux';

export default function useSelectedVideo() {
  return useSelector(state => state.layout.selectedVideo);
}
